// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"5e2e0fe1","242":"1d27423b"}[chunkId] + ".chunk.js";
};